import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminDataService from "../../services/admin.service";

// FORM VALIDATION
import { useFormik } from "formik";
import * as Yup from "yup";

import BackButton from "../BackButton";

const Member = (props) => {
    const initialMemberState = {
        id: null,
        username: "",
        email: "",
        password: "",
    };
    const [currentMember, setCurrentMember] = useState(initialMemberState);
    const [message, setMessage] = useState("");
    const [updatePsw, setUpdatePsw] = useState(false);

    const { id } = useParams();
    let navigate = useNavigate();

    const getMember = (id) => {
        AdminDataService.get(id)
            .then((response) => {
                setCurrentMember(response.data);
                formik.values = {
                    username: response.data.username,
                    email: response.data.email,
                    password: response.data.password,
                };
                console.log("formik.values", formik.values);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    useEffect(() => {
        if (id) getMember(id);
    }, [id]);

    // FORM VALIDATION
    const form = useRef();
    const checkBtn = useRef();

    const [successful, setSuccessful] = useState(false);

    // const message = useSelector(selectMessage);
    // const dispatch = useDispatch();

    const usernameValidator = Yup.string()
        .required("Username is required")
        .min(6, "Username must be at least 6 characters")
        .max(20, "Username must not exceed 20 characters");

    const emailValidator = Yup.string()
        .required("Email is required")
        .email("Email is invalid");

    const passwordValidator = Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters")
        .max(40, "Password must not exceed 40 characters");

    const validationSchema = Yup.object().shape(
        updatePsw
            ? {
                  username: usernameValidator,
                  email: emailValidator,
                  password: passwordValidator,
              }
            : {
                  username: usernameValidator,
                  email: emailValidator,
              }
    );

    const formik = useFormik({
        initialValues: {
            username: currentMember.username,
            email: currentMember.email,
            // password: currentMember.password,
            password: "",
        },
        enableReinitialize: true,
        validationSchema,
        // validateOnChange: false,
        // validateOnBlur: false,
        onSubmit: () => {
            AdminDataService.update(
                currentMember.id,
                updatePsw
                    ? formik.values
                    : {
                          username: formik.values.username,
                          email: formik.values.email,
                      }
            )
                .then((response) => {
                    setSuccessful(true);
                    console.log(response.data);
                    setMessage("The User was updated successfully!");
                    navigate("/members");
                })
                .catch((e) => {
                    setSuccessful(false);
                    console.log(e);
                });
        },
    });

    const deleteMember = () => {
        AdminDataService.remove(currentMember.id)
            .then((response) => {
                console.log(response.data);
                navigate("/members");
            })
            .catch((e) => {
                // console.log(e);
                window.alert(e.response.data.message);
            });
    };

    const handleClickUpdatePsw = () => {
        setUpdatePsw(!updatePsw);
        if (updatePsw) {
            setPswType("password");
        }
    };

    const [pswType, setPswType] = useState("password");

    const toggleShowPsw = () => {
        if (pswType === "password") {
            setPswType("text");
        } else {
            setPswType("password");
        }
    };

    return (
        <div>
            {currentMember ? (
                <div className="col-md-12 module-form">
                    <BackButton returnPath="/members"></BackButton>

                    <h4 className="page-title">Update member</h4>

                    <form onSubmit={formik.handleSubmit} ref={form}>
                        {!successful && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="username"> Username </label>
                                    <input
                                        name="username"
                                        type="text"
                                        className={
                                            "form-control" +
                                            (formik.errors.username &&
                                            formik.touched.username
                                                ? " is-invalid"
                                                : "")
                                        }
                                        onChange={formik.handleChange}
                                        value={formik.values.username}
                                    />
                                    <div className="invalid-feedback">
                                        {formik.errors.username &&
                                        formik.touched.username
                                            ? formik.errors.username
                                            : null}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email"> Email </label>
                                    <input
                                        name="email"
                                        type="email"
                                        className={
                                            "form-control" +
                                            (formik.errors.email &&
                                            formik.touched.email
                                                ? " is-invalid"
                                                : "")
                                        }
                                        onChange={formik.handleChange}
                                        value={formik.values.email}
                                    />
                                    <div className="invalid-feedback">
                                        {formik.errors.email &&
                                        formik.touched.email
                                            ? formik.errors.email
                                            : null}
                                    </div>
                                </div>

                                <hr></hr>

                                <div className="form-group">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="checkUpdatePsw"
                                            onClick={handleClickUpdatePsw}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="checkUpdatePsw"
                                        >
                                            Update password
                                        </label>
                                    </div>

                                    <label htmlFor="password"> Password </label>
                                    <div className="input-group">
                                        <input
                                            name="password"
                                            type={pswType}
                                            className={
                                                "form-control" +
                                                (formik.errors.password &&
                                                formik.touched.password
                                                    ? " is-invalid"
                                                    : "")
                                            }
                                            onChange={formik.handleChange}
                                            value={
                                                updatePsw &&
                                                formik.values.password
                                            }
                                            disabled={!updatePsw}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={toggleShowPsw}
                                            style={{
                                                borderRadius: "0 6px 6px 0",
                                            }}
                                            disabled={!updatePsw}
                                        >
                                            {pswType === "password" ? (
                                                <i class="bi bi-eye" />
                                            ) : (
                                                <i class="bi bi-eye-slash" />
                                            )}
                                        </button>
                                        <div className="invalid-feedback">
                                            {formik.errors.password &&
                                            formik.touched.password
                                                ? formik.errors.password
                                                : null}
                                        </div>
                                    </div>
                                </div>

                                <hr></hr>

                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        Update
                                    </button>{" "}
                                    <button
                                        type="button"
                                        className="btn btn-danger float-right"
                                        onClick={deleteMember}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* {message && (
                            <div className="form-group">
                                <div
                                    className={
                                        successful
                                            ? "alert alert-success"
                                            : "alert alert-danger"
                                    }
                                    role="alert"
                                >
                                    {message}
                                </div>
                            </div>
                        )}
                        <button
                            style={{ display: "none" }}
                            ref={checkBtn}
                        ></button> */}
                    </form>
                </div>
            ) : (
                <div>
                    <br />
                    <p>Please click on a User...</p>
                </div>
            )}
        </div>
    );
};

export default Member;
